import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";

import {
  IDoublePanelFieldConfigurationClient,
  IDoublePanelFieldConfigurationServer,
} from "./interface";

export const transformDoublePanelFieldConfigClientToServer = (
  fieldConfigClient: IDoublePanelFieldConfigurationClient
): IDoublePanelFieldConfigurationServer => {
  const {
    leftPanelConfiguration,
    rightPanelConfiguration,
    isShowCountEnabled,
    initialValue,
    placeholder,
  } = fieldConfigClient;

  const fieldConfigServer = {
    leftPanelConfiguration: leftPanelConfiguration,
    rightPanelConfiguration: rightPanelConfiguration,
    placeHolder: placeholder,
    initialValue: initialValue,
    isShowCountEnabled: isShowCountEnabled,
  };
  return fieldConfigServer;
};

export const transformDoublePanelFieldConfigServerToClient = (
  fieldConfigServer: IDoublePanelFieldConfigurationServer
): IDoublePanelFieldConfigurationClient => {
  const {
    leftPanelConfiguration,
    rightPanelConfiguration,
    isShowCountEnabled,
    isNegativeAllowed,
    initialValue,
    placeHolder,
  } = fieldConfigServer;
  const fieldConfigClient = {
    leftPanelConfiguration: leftPanelConfiguration,
    rightPanelConfiguration: rightPanelConfiguration,
    isShowCountEnabled: isShowCountEnabled,
    isNegative: isNegativeAllowed,
    initialValue: initialValue,
    placeholder: placeHolder,
  };
  return fieldConfigClient;
};

export const validateDoublePanelFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

  if (isRequired && !!isVisible) {
    if (!submissionValue) {
      return [false, "This is a Required Field"];
    }
  }

  return [true, ""];
};
